import { render } from "./DashboardReports.vue?vue&type=template&id=6934d290&scoped=true"
import script from "./DashboardReports.vue?vue&type=script&lang=js"
export * from "./DashboardReports.vue?vue&type=script&lang=js"

import "./DashboardReports.vue?vue&type=style&index=0&id=6934d290&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6934d290"]])

export default __exports__